import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {DiffToNow, PadZero} from "../../utils/date-utils";
import {fetchCodeAttempts} from "../../store/codesSlice";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";

const InformationBlock: React.FC = () => {
    const slideState = useAppSelector((state) => state.slide)
    const codesData = useAppSelector((state) => state.codes)
    const codeStatus = codesData.status;
    const dispatch = useAppDispatch();
    const [timeLeft, setTimeLeft] = useState(DiffToNow(codesData.next_attempt_time));

    useEffect(() => {
        if(codeStatus === 'fulfilled_max') {
            const timer = setInterval(() => {
                const left = DiffToNow(codesData.next_attempt_time);
                setTimeLeft(left);
                if(left.hours === 0 && left.minutes === 0 && left.seconds === 0) {
                    clearInterval(timer);
                    dispatch(fetchCodeAttempts());
                }
            }, 1000);
            return () => clearInterval(timer); // Clean up interval on component unmount
        }
    }, [dispatch, codeStatus, codesData.next_attempt_time]);

    return (
        <Container>
            {slideState.completed_at &&
                <P>Code is claimed!<br/>
                    You have claimed this code</P>
            }
            {!slideState.completed_at && codeStatus === 'fulfilled_incorrect' &&
                <P>Wrong code.<br/>
                    You have {codesData.remaining_attempts} attempts left</P>
            }

            {!slideState.completed_at && codeStatus === 'fulfilled_max' &&
                <Wrapper>
                    <P>Too many attempts, please wait</P>
                    {!isNaN(timeLeft.minutes) &&
                        <Timer>{`${PadZero(timeLeft.minutes)}:${PadZero(1 + timeLeft.seconds)}`}</Timer>
                    }
                </Wrapper>
            }
        </Container>
    );
};

export default InformationBlock;

const Container = styled.div`
    padding: 16px 24px;
`;
const P = styled.p`
    font-size: 1.9vh;
    font-weight: 700;
    margin: 0;
`;
const Wrapper = styled.div`
    text-align: center;
`;
const Timer = styled.h1`
    font-family: 'ZenDots', sans-serif;
    font-size: 48px;
    margin: 0;
    position: relative;
    cursor: pointer;
`;
